/* ATHLETIX / Matchday film — lazy autoplay, visibility pause, accessible controls */
(() => {
  function initialize(root) {
    const sections = root.querySelectorAll ? root.querySelectorAll('[data-ath-matchday]') : [];
    sections.forEach((section) => {
      if (section.dataset.athMatchdayInitialized === 'true') return;
      section.dataset.athMatchdayInitialized = 'true';

      const video = section.querySelector('[data-ath-matchday-video]');
      const button = section.querySelector('[data-ath-matchday-toggle]');
      if (!video) return;

      video.muted = true;
      let inView = false;
      let manuallyPaused = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let observer = null;

      function updateButton() {
        if (!button) return;
        const paused = manuallyPaused || reducedMotion.matches || video.paused;
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
        const label = button.querySelector('[data-ath-matchday-toggle-label]');
        if (label) label.textContent = paused ? 'Play film' : 'Pause film';
      }

      function synchronize() {
        const canPlay = inView && !manuallyPaused && !reducedMotion.matches && !document.hidden;
        if (canPlay) {
          const result = video.play();
          if (result && typeof result.catch === 'function') result.catch(updateButton);
        } else {
          video.pause();
        }
        updateButton();
      }

      video.addEventListener('playing', () => {
        section.classList.add('is-video-ready');
        updateButton();
      });
      video.addEventListener('pause', updateButton);

      if (button) button.addEventListener('click', () => {
        manuallyPaused = !manuallyPaused;
        synchronize();
      });

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          inView = entries.some((entry) => entry.isIntersecting);
          synchronize();
        }, { rootMargin: '100px 0px', threshold: 0.15 });
        observer.observe(section);
      } else {
        inView = true;
        synchronize();
      }

      document.addEventListener('visibilitychange', synchronize);
      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', synchronize);
      updateButton();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document));
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    if (root?.matches?.('[data-ath-matchday]')) initialize(root.parentNode);
    else initialize(root);
  });
})();
